module.exports = __webpack_public_path__ + "static/media/ivete_03.04680dda.mp4";